"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const findProc = require("find-process");
const fs = require("fs");
const child_process_1 = require("child_process");
const yauzl = require("yauzl-promise");
const path = require("path");
const uuid_1 = require("uuid");
const nanoid_1 = require("nanoid");
class Util {
    static readableFileSizeString(bytes, si = true) {
        const threshold = si ? 1000 : 1024;
        if (Math.abs(bytes) < threshold) {
            return bytes + ' B';
        }
        const units = si
            ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
            : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        let u = -1;
        do {
            bytes /= threshold;
            ++u;
        } while (Math.abs(bytes) >= threshold && u < units.length - 1);
        return bytes.toFixed(1) + ' ' + units[u];
    }
    static relativeDateTimeStringFromDBTimestamp(timestamp) {
        if (timestamp._seconds) {
            return this.relativeDateTimeString(new Date(timestamp._seconds * 1000 + +(timestamp._nanoseconds / 1000000000.0)));
        }
        else {
            return this.relativeDateTimeString(new Date(timestamp));
        }
    }
    static relativeDateTimeString(date) {
        if (!date) {
            return "";
        }
        if (!date.getTime) {
            return date.toLocaleString();
        }
        const delta = Math.round((+new Date() - date.getTime()) / 1000);
        const minute = 60;
        const hour = minute * 60;
        const day = hour * 24;
        const week = day * 7;
        let formattedString;
        if (delta < 30) {
            formattedString = 'just now';
        }
        else if (delta < minute) {
            formattedString = delta + ' seconds ago.';
        }
        else if (delta < 2 * minute) {
            formattedString = 'a minute ago';
        }
        else if (delta < hour) {
            formattedString = Math.floor(delta / minute) + ' minutes ago';
        }
        else if (Math.floor(delta / hour) === 1) {
            formattedString = '1 hour ago';
        }
        else if (delta < day) {
            formattedString = Math.floor(delta / hour) + ' hours ago';
        } /*else if (delta > day && delta < day * 2) {
            const daysAgo = Math.floor(delta / day);
            formattedString = `${daysAgo} ${daysAgo === 1 ? "day" : "days"} ago`;
        } */
        else {
            formattedString = date.toLocaleString();
        }
        return formattedString;
    }
    static formatBytes(bytes, decimals = 2) {
        if (bytes === 0) {
            return '0B';
        }
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + '' + sizes[i];
    }
}
exports.default = Util;
Util.generateNewId = (type = "uuidv4", length = 6) => {
    if (type === "uuidv4") {
        return uuid_1.v4();
    }
    else if (type === "nanoid") {
        const charset = "123456789abcdefghjkmnpqrstuvwxyz";
        return nanoid_1.customAlphabet(charset, length)();
    }
    return uuid_1.v4().toString();
};
Util.debounce = (fn, n, immediate = false) => {
    let timer;
    return function (...args) {
        if (timer === undefined && immediate) {
            fn.apply(this, args);
        }
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => fn.apply(this, args), n);
        return timer;
    };
};
Util.throttle = (func, waitFor) => {
    const now = () => new Date().getTime();
    const resetStartTime = () => startTime = now();
    let timeout;
    let startTime = now() - waitFor;
    return (...args) => new Promise((resolve) => {
        const timeLeft = (startTime + waitFor) - now();
        if (timeout) {
            clearTimeout(timeout);
        }
        if (startTime + waitFor <= now()) {
            resetStartTime();
            resolve(func(...args));
        }
        else {
            timeout = setTimeout(() => {
                resetStartTime();
                resolve(func(...args));
            }, timeLeft);
        }
    });
};
Util.promiseAllConcurrent = (n, list) => __awaiter(void 0, void 0, void 0, function* () {
    const head = list.slice(0, n);
    const tail = list.slice(n);
    const result = [];
    const execute = (promise, i, next) => __awaiter(void 0, void 0, void 0, function* () {
        result[i] = yield promise();
        yield runNext();
    });
    const runNext = () => __awaiter(void 0, void 0, void 0, function* () {
        const i = list.length - tail.length;
        const promise = tail.shift();
        if (promise !== undefined) {
            yield execute(promise, i, runNext);
        }
    });
    yield Promise.all(head.map((promise, i) => execute(promise, i, runNext)));
    return result;
});
Util.sleep = (ms) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, ms);
    });
};
Util.killProcessByNameAndWaitForExit = (processName, timeoutMS = 10000) => __awaiter(void 0, void 0, void 0, function* () {
    const runningProcesses = yield Util.findProcessByName(processName);
    if (runningProcesses && runningProcesses.length > 0) {
        console.log(`found ${runningProcesses.length} instance(s) of ${processName} running locally, killing them`);
        for (const rp of runningProcesses) {
            yield Util.killProcessAndWaitForExit(rp.pid, timeoutMS);
        }
    }
    else {
        console.log(`no instances of ${processName} are running`);
    }
});
Util.killProcessAndWaitForExit = (pid, timeoutMs = 10000) => {
    return new Promise((resolve, reject) => {
        const checkFrequencyMs = 200;
        let msElapsed = 0;
        // check if the process is still running
        setInterval(() => {
            try {
                process.kill(pid, 0);
            }
            catch (error) {
                // the process has exited, resolve our promise
                resolve();
            }
            msElapsed += checkFrequencyMs;
            if (msElapsed > timeoutMs) {
                reject("timeout");
            }
        }, checkFrequencyMs);
        // asynchronously send a SIGTERM signal
        process.kill(pid, "SIGINT");
    });
};
Util.isProcessRunning = (processName) => __awaiter(void 0, void 0, void 0, function* () {
    const runningProcesses = yield Util.findProcessByName(processName);
    return runningProcesses && runningProcesses.length > 0;
});
Util.findProcessByName = (processName) => __awaiter(void 0, void 0, void 0, function* () {
    const runningProcesses = yield findProc("name", processName);
    if (runningProcesses && runningProcesses.length > 0) {
        return runningProcesses;
    }
    else {
        return [];
    }
});
Util.startProcess = (processPath, workingDirectory, detachFromParent) => __awaiter(void 0, void 0, void 0, function* () {
    // make the file executable
    yield fs.promises.chmod(processPath, 0o755);
    if (detachFromParent) {
        const spawnedProcess = child_process_1.spawn(processPath, {
            detached: true,
            stdio: "ignore",
            windowsHide: true,
            cwd: workingDirectory
        });
        spawnedProcess.unref(); // detach from this process
    }
    else {
        return child_process_1.spawnSync(processPath, { cwd: workingDirectory });
    }
});
Util.unzipFile = (filePath, targetDirectory) => __awaiter(void 0, void 0, void 0, function* () {
    const zipFile = yield yauzl.open(filePath, { lazyEntries: true });
    yield zipFile.walkEntries((entry) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (entry.fileName.endsWith("/")) {
                // skip
            }
            else {
                const entryStream = yield entry.openReadStream();
                entryStream.on("error", (error) => {
                    console.error(`failed to read zip entry: ${entry.fileName} ${error}`);
                });
                const targetFilename = path.join(targetDirectory, entry.fileName);
                const targetPath = path.dirname(targetFilename);
                if (!fs.existsSync(targetPath)) {
                    fs.mkdirSync(targetPath, { recursive: true });
                }
                const outStream = fs.createWriteStream(targetFilename);
                outStream.on("error", (error) => {
                    console.error(`failed to output zip entry: ${entry.fileName} ${error}`);
                });
                entryStream.pipe(outStream);
            }
        }
        catch (err) {
            console.error(err);
        }
    }));
    yield zipFile.close();
});
Util.compareVersions = (versionA, versionB) => {
    if (!versionA || !versionB)
        return 1;
    if (versionA.major !== versionB.major)
        if (versionA.major > versionB.major)
            return 1;
        else
            return -1;
    if (versionA.minor !== versionB.minor)
        if (versionA.minor > versionB.minor)
            return 1;
        else
            return -1;
    if (versionA.build != versionB.build)
        if (versionA.build > versionB.build)
            return 1;
        else
            return -1;
    return 0;
};
Util.generateRdpFile = (address) => {
    let fdata = "";
    fdata += "full address:s:" + address + "\n";
    return fdata;
};
Util.getArrayUniqueItems = (array) => {
    return array.filter((value, index) => {
        return array.indexOf(value) === index;
    });
};
//# sourceMappingURL=Util.js.map